import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { UserServiceProxy } from '@shared/service-proxies/service-proxies';
@Component({
    selector: 'app-private-data',
    templateUrl: './private-data.page.html',
    styleUrls: ['./private-data.page.scss'],
  })
  export class PrivateDataPage implements OnInit {
    
    message:string;
  formGroup : FormGroup;
  ngOnInit(): void {
  
  }
  constructor( private formBuilder: FormBuilder, private userService: UserServiceProxy){
this.setupForm();
  }
  setupForm() {
    if (this.formGroup) {
      this.formGroup.reset();
    }
    this.formGroup = this.formBuilder.group({
      emailAddress: ['', Validators.required],
    });
   
  }
  submitForm(){
    this.userService.requestDeletePrivateData(this.formGroup.controls['emailAddress'].value).subscribe(x=>
      this.message = "Your information has been submitted"
    )
  }
  }